import { Control, FieldError } from 'react-hook-form';
import styled from '@emotion/styled';
import { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import { TextFieldProps } from '@mui/material/TextField';
import { Rules, WithDataTestId } from '@myme/utils';

// STYLES

export const FormFieldContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: min-content minmax(1.3rem, min-content);
  padding: 3px 0;
`;

// TYPES

interface CommonFormProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  name: string;
  rules?: Rules;
  isError?: boolean | FieldError;
  errorMsg?: string;
}

type CheckboxProps = MuiCheckboxProps & WithDataTestId;
export interface FormCheckboxProps extends CommonFormProps {
  description: React.ReactNode;
  checkboxProps?: CheckboxProps;
  defaultValue?: boolean;
  testId?: string;
}

export interface FormFieldProps extends CommonFormProps {
  inputProps?: TextFieldProps;
  defaultValue?: string;
  helperMessage?: string;
}

interface SelectOption {
  text: string;
  value: string | number;
}

export interface FormSelectProps extends FormFieldProps {
  options: SelectOption[];
}
